import {DataContext} from "../Context/DataContext";
import {useState} from "react";
import Navbar from "../Navbar/Navbar";
import MemberpayList from "../MemberpayList";

function CustomerMemberPaylist(){
    const[searchUi,setSearchUi]=useState(false)
    const[searchContent,setSearchContent]=useState('')
    return(

        <DataContext.Provider value={{searchUi,setSearchUi,searchContent,setSearchContent}}>
        <Navbar 
         navId={44}
        childrenPage={<MemberpayList/>}/>
        </DataContext.Provider>
    )
}

export default CustomerMemberPaylist;